import { render, staticRenderFns } from "./Table13.vue?vue&type=template&id=55f4d2f8&scoped=true&"
import script from "./Table13.vue?vue&type=script&lang=js&"
export * from "./Table13.vue?vue&type=script&lang=js&"
import style0 from "./Table13.vue?vue&type=style&index=0&id=55f4d2f8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f4d2f8",
  null
  
)

export default component.exports